import axios from "axios";
import * as Sentry from "@sentry/react";
import { trainingAPI } from "../../api/TrainingAPI";
import { getTeamInformation } from "./team.actions";

export const MANAGER_SET_TEAM_LIST = "[MANAGER]_SET_TEAM_LIST";
export const MANAGER_SET_SELECTED_TEAM = "[MANAGER]_SET_SELECTED_TEAM";

export const INITIALIZE_STORE = "INITIALIZE_STORE";

export const setManagerTeamList = (data, status) => {
  return {
    type: MANAGER_SET_TEAM_LIST,
    data,
    status,
  };
};

export const setManagerSelectedTeam = (data) => {
  return {
    type: MANAGER_SET_SELECTED_TEAM,
    data,
  };
};


export const getManagerTeamList = () => {
  return async (dispatch) => {
    try {
      const { data, status } = await trainingAPI.getTeamList({ list_only: true });
      dispatch(setManagerTeamList(Array.isArray(data) ? data : [], status));
    } catch (e) {
      // Axios rejects on any non-2xx. A missing `response` means the request
      // never reached the server (network/CORS/timeout) — represented as 0.
      const status = e?.response?.status ?? 0;
      if (status === 0 || status >= 500) {
        Sentry.captureException(e);
      }
      dispatch(setManagerTeamList([], status));
    }
  };
};

export const initializeStore = () => {
  return {
    type: INITIALIZE_STORE,
  };
};

export const selectManagerTeam = (teamId, navigate) => {
  return async (dispatch, getState) => {
    const teams = getState().manager.teams;
    if (!teams || teams.length === 0) return;

    const isTeamIdValid = teams.some((team) => team.id == teamId);
    if (!isTeamIdValid) {
      localStorage.removeItem("team-id");
      delete axios.defaults.headers.common["gpsdv-team-id"];
      await dispatch(setManagerSelectedTeam(undefined));
      await dispatch(initializeStore());
      navigate("/team-selection");
      return false;
    } else {
      localStorage.setItem("team-id", teamId);
      axios.defaults.headers.common["gpsdv-team-id"] = teamId;
      await dispatch(setManagerSelectedTeam(teamId));
      await dispatch(initializeStore());
      await dispatch(getTeamInformation());
      return true;
    }
  };
};
